<template>
	<transition name="fade" mode="out-in">
	  <router-view/>
    <!--<router-view v-if="routerInto"/>-->
	  
	</transition>
</template>

<script>
import Vue from 'vue'

//引入emelent-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入公共样式
import '@/assets/css/pc_main.css'
Vue.use(ElementUI,{size:'small'});
//引入编辑器
import '../static/UE/ueditor.config.js'
import '../static/UE/ueditor.all.min.js'
import '../static/UE/lang/zh-cn/zh-cn.js'
import '../static/UE/ueditor.parse.min.js'

// import SuperFlow from 'vue-super-flow'
// import 'vue-super-flow/lib/index.css'

// Vue.use(SuperFlow);

export default {
	data() {
    return {
      routerInto:false
    };
  },

  mounted(){
    // var that=this;
    // that.$store.dispatch('getLangPackByBackstage').then(langPackData=>{
    //   console.log(langPackData);
    //   that.$rwJS.lang=langPackData;
    //   that.$nextTick(()=>{
    //     that.routerInto=true;
    //   });
    // });
  },
  watch:{
  	
  }
  
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue